<template>
  <video
    :key="coverUrl"
    ref="video"
    width="100%"
    controls="true"
    preload="metadata"
    :poster="coverSrc"
    class="video-mux"
    @play="handlePlay"
  />
</template>

<script>
import { getCoverSrc } from '@/components/common/VideoPlayer/utils';

export default {
  name: 'VideoMux',
  props: {
    muxPlaybackId: {
      type: String,
      default: '',
      required: true,
    },
    coverUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      player: null,
    };
  },
  computed: {
    coverSrc() {
      if (this.coverUrl && this.coverUrl.startsWith('http')) {
        return getCoverSrc(this.coverUrl);
      }

      return this.coverUrl;
    },
  },
  updated() {
    this.destroyVideoPlayer();
    this.initVideoPlayer();
  },
  mounted() {
    this.initVideoPlayer();
  },
  beforeDestroy() {
    this.destroyVideoPlayer();
  },
  methods: {
    handlePlay() {
      if (this.player) {
        this.player.startLoad();
      }
    },
    destroyVideoPlayer() {
      if (this.player) {
        this.player.stopLoad();
        this.player.destroy();
      }
    },
    initVideoPlayer() {
      const url = `https://stream.mux.com/${this.muxPlaybackId}.m3u8`;
      const video = this.$refs.video;

      import('hls.js').then(({ default: Hls }) => {
        if (Hls.isSupported()) {
          this.player = new Hls({ autoStartLoad: !this.coverUrl });

          let firstChunkLoaded = false;
          this.player.on(Hls.Events.LEVEL_LOADED, () => {
            if (firstChunkLoaded) {
              this.player.stopLoad();
            }
            firstChunkLoaded = true;
          });

          this.player.loadSource(url);
          this.player.attachMedia(video);
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = url;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.video-mux {
  background: rgba(var(--black));
  object-fit: contain;
  outline: none;
  height: 100%;
  max-height: 280px;
  flex-grow: 1;
}
</style>
